module.exports = {"validation":{"required":"Dit veld is vereist","email":"Ongeldig e-mailadres"}}